import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export function SearchBar() {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    // TODO: Implement actual search functionality
  };

  return (
    <div className="relative">
      <Search
        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400"
        size={20}
      />
      <Input
        type="text"
        placeholder="Search matches and conversations..."
        value={searchQuery}
        onChange={handleSearch}
        className="pl-10 bg-gray-800 border-gray-700 text-gray-100 placeholder-gray-400"
      />
    </div>
  );
}
